// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.error-class[data-v-88aee192] {\n  color: #f00;\n}\n.id-column[data-v-88aee192] {\n  max-width: 123px;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n}\n.td[data-v-88aee192] {\n  font-size: 11px;\n}\n", ""]);
// Exports
module.exports = exports;
